export default function useReorderChapters(){

    return (chapters) => {
        
        let newChapters = [...chapters]
            .sort((a,b) => a.rank - b.rank)
            .map((c,i) => {
                return {...c, rank: i + 1}
            })
        
        return newChapters;
    }
}